import { SearchPropertyStatus } from '../types';

export const hasStatusChangedFromOnMarketToOffMarket = ({
  previousStatus,
  newStatus,
}: {
  previousStatus: SearchPropertyStatus;
  newStatus: SearchPropertyStatus;
}): boolean =>
  newStatus !== SearchPropertyStatus.forSale &&
  newStatus !== SearchPropertyStatus.forRent &&
  (previousStatus === SearchPropertyStatus.forSale ||
    previousStatus === SearchPropertyStatus.forRent);
